// @ts-strict-ignore
import getBarOptions from '@/hybrid/tableBuilder/tableViewer/chartConfigs/bar';

const getBarStackedOptions = (tableData, settings) => getBarOptions(tableData, { ...settings, stacked: true });
export default getBarStackedOptions;
